import { from } from 'rxjs';
import { map } from 'rxjs/operators';

import { resolveRestApi } from '../../router/app-router';
import { fetch } from '../../service_broker/fetch';
import { ACTION_DELETE_CASE_IN_CREATESTAGE } from '../../store/state/actions';
import { processHeaders } from '../../store/state/epics/util';
import { logAndCatchError } from '../../utils/rxjs-utils';
import type { Action } from '../../store/state/state-manager';
import ObjectTransformer from '../../utils/object-transformer';

export const executeDeleteCaseInCreateStageRequest = (actionInPayload: Action['payload']) => {
  const { caseID, context } = actionInPayload;
  const { restApi, reqType } = resolveRestApi(ACTION_DELETE_CASE_IN_CREATESTAGE, { ID: caseID });

  return from(
    fetch(
      restApi,
      {
        method: reqType
      },
      context
    )
  ).pipe(
    map((response) => {
      ObjectTransformer.analyseResponse(response.data);
      return {
        response: response.data,
        actionInPayload,
        headers: processHeaders(response.headers)
      };
    }),
    logAndCatchError(': Error occurred during ajax call at deleteCaseInCreateStage Epic : ', context)
  );
};

export default {
  executeDeleteCaseInCreateStageRequest
};
